import React from 'react'
import { Column, ColumnFixing, ColumnChooser, DataGrid, Pager, Paging,
    FilterRow, HeaderFilter} from 'devextreme-react/data-grid';

const DevGrid = (props) => {



    const getDuzenleSilButton = (prp) => {
        let buttons = [];
        if (prp.duzenleFnc) {
            buttons.push( {hint: 'Düzenle',icon: 'edit', onClick: prp.duzenleFnc})
        }

        if (prp.silFnc) {
            buttons.push( {hint: 'Sil',icon: 'trash', onClick: prp.silFnc})
        }
        return <Column type="buttons" buttons={buttons} />
    }

    const onToolbarPreparing = (e, prp) => {
        if (prp.ekleFnc) {
            e.toolbarOptions.items.unshift(
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon:"add",
                        onClick: prp.ekleFnc
                    }
                });
        }
    }

    return <>
     <DataGrid
        className={'dx-card wide-card'}
        showBorders={true}
       //focusedRowEnabled={true}
        //defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        columnResizingMode={"widget"}
        columnHidingEnabled={true}
        remoteOperations={true}
        onToolbarPreparing={(e) => onToolbarPreparing(e, props)}

     {...props}
    >


                <FilterRow visible={true}  applyFilter={"onClick"}/>
                <ColumnFixing enabled={true} />
                <HeaderFilter visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />

                {props.children}

         {props.silFnc || props.duzenleFnc ? getDuzenleSilButton(props) : null}



<Paging defaultPageSize={10} />
                <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[3,5,7]}
                />


    </DataGrid>
    </>;
}

export default DevGrid;
